import { Component } from "@angular/core";
import { UserRolesPermissionsComponent } from "../user-roles-permissions/user-roles-permissions.component";
import { UserManagementComponent } from "../user-management/user-management.component";
import { PermissionService } from "../../../services/permission.service";
import { PermissionConstants } from "../../../constants/permission-constants";
import { RequiresPermissionDirective } from "../../../directives/evaluate-permission.directive";

@Component({
  selector: "app-manage-users",
  standalone: true,
  imports: [UserRolesPermissionsComponent, UserManagementComponent, RequiresPermissionDirective],
  templateUrl: "./manage-users.component.html",
  styleUrl: "./manage-users.component.scss"
})
export class ManageUsersComponent {
  selectedTab: string = "users"; // 'users' // roles;

  constructor(private permissionService: PermissionService) {
  }

  ngOnInit() {
    if (this.permissionService.evaluatePermissionsForLoggedInUser({ permissionIds: [PermissionConstants.USERS.LIST] })) {
      this.selectedTab = "users";
    } else {
      this.selectedTab = "roles";
    }
    this.selectedTab = history.state?.selectedTab ?? this.selectedTab;
  }

  selectTab(tabName: string) {
    this.selectedTab = tabName;
  }

  protected readonly PermissionConstants = PermissionConstants;
}
